import type { PhoneCall } from '@/features/phone-calls/hooks'

export const UNANSWERED = new Set(['missed', 'no-answer', 'busy', 'abandoned', 'canceled', 'failed'])

/** "Incoming call · 4m 12s · Sam" */
export function callLine(call: PhoneCall) {
  const unanswered = UNANSWERED.has(call.status)
  const kind = unanswered
    ? call.has_voicemail
      ? 'Voicemail'
      : 'Missed call'
    : call.direction === 'incoming'
      ? 'Incoming call'
      : 'Outgoing call'
  const minutes = Math.floor(call.duration_seconds / 60)
  const seconds = call.duration_seconds % 60
  const length = call.duration_seconds
    ? minutes
      ? `${minutes}m ${String(seconds).padStart(2, '0')}s`
      : `${seconds}s`
    : null
  return [kind, length, call.staff_name].filter(Boolean).join(' · ')
}
